// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"7a862fd2","239":"b76c5a80","389":"7a388286","455":"ac3f55f4","857":"1631a328","977":"2d3ab885"}[chunkId] + ".chunk.js";
};